<template>
  <v-container class="pa-0 justify-center" fluid>
    <v-snackbar
      v-model="snackbar.value"
      location="top"
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <template #actions>
        <v-btn icon variant="text" @click="snackbar.value = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <!-- TOOLBAR -->
    <v-toolbar color="red-darken-3" flat>
      <v-toolbar-title class="hidden-sm-and-down">
        {{ institution.title }}
      </v-toolbar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-form ref="form2" v-model="valid" lazy-validation>
          <v-container grid-list-md>
            <v-row wrap>
              <!------------------------------------UPLOAD LOGO------------------------------------>
              <v-col xs="8" md="8" lg="8">
                <v-row row wrap>
                  <!-- Text "Company Logo" in one column (xs="4") -->
                  <v-col xs="4" md="4" lg="4">
                    <label style="padding-right: 10px">{{
                      $t("institutions.form.upload_logo")
                    }}</label>
                    <v-tooltip bottom>
                      <template #activator="{ on, attrs }">
                        <v-icon small v-bind="attrs" v-on="on"> info </v-icon>
                      </template>
                      <span
                        >72 x 72 {{ $t("institutions.form.preferred") }}</span
                      >
                    </v-tooltip>
                  </v-col>

                  <!-- Display institution's logo if available, or uploaded logo -->
                  <v-col xs="8" md="8" lg="8">
                    <!-- File input -->
                    <v-row row>
                      <v-col xs="12" md="12" lg="18">
                        <input
                          ref="logoInput"
                          accept="image/*"
                          type="file"
                          @change="onInput"
                        />
                      </v-col>
                    </v-row>
                    <!-- Use a template with v-if and v-else for conditional rendering -->
                    <template v-if="!logo">
                      <!-- Display institution's logo with the server URL -->
                      <div class="logo-container pt-4">
                        <img
                          v-if="institution.logo"
                          :src="
                            institution && institution.logo
                              ? `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${institution.logo}`
                              : `https://portal.lekotech.com/logo_small.png`
                          "
                          :style="{ 'max-width': '300px' }"
                          alt="Company Logo"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <!-- Display uploaded logo if no institution logo is available -->
                      <div class="logo-container pt-4">
                        <img
                          v-if="logo"
                          :src="tmpLogo"
                          :style="{ 'max-width': '300px' }"
                          alt="Company Logo"
                        />
                      </div>
                    </template>

                    <!-- Other content -->
                    <v-row row>
                      <v-col xs="12" md="12" lg="12">
                        <!-- Add your other content here -->
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col xs="4" md="4" lg="4">
                <v-row>
                  <v-col xs="12" md="12" lg="12">
                    <label style="padding-right: 10px">{{
                      $t("inventory_details")
                    }}</label>
                  </v-col>
                  <v-col xs="6" md="6" lg="6">
                    <v-row class="d-flex flex-nowrap">
                      <v-col class="pl-3" xs="12" md="12" lg="12">
                        <p>
                          <v-icon class="mx-1" color="grey-darken-2">
                            mdi-account
                          </v-icon>
                          <strong>{{ $t("history.users") }}: </strong>
                          {{ institution.usersCount }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex flex-nowrap">
                      <v-col class="pl-3" xs="12" md="12" lg="12">
                        <p>
                          <v-icon class="mx-1" color="grey-darken-2">
                            mdi-archive
                          </v-icon>
                          <strong
                            >{{ $t("institutions.table.inventory") }}: </strong
                          >{{ institution.partsCount }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex flex-nowrap pb-0 mb-0">
                      <v-col class="pl-3" xs="12" md="12" lg="12">
                        <p>
                          <v-icon class="mx-1" color="grey-darken-2">
                            mdi-car
                          </v-icon>
                          <strong
                            >{{ $t("institutions.form.plates") }}:
                          </strong>
                          {{
                            institution &&
                            institution.plates &&
                            institution.plates.used
                              ? institution.plates.used
                              : 0
                          }}/{{
                            institution &&
                            institution.plates &&
                            institution.plates.remaining
                              ? institution.plates.remaining
                              : 0
                          }}
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="d-flex flex-nowrap pt-0 mt-0">
                      <v-col class="pl-3 pt-0 mt-0" xs="12" md="12" lg="12">
                        <small>
                          ({{ $t("institutions.form.total_plates") }} /{{
                            $t("institutions.form.remaining_plates")
                          }})
                        </small>
                      </v-col></v-row
                    >
                  </v-col>
                </v-row>
              </v-col>
              <!---------------------------------------TITLE--------------------------------------->
              <v-col cols="12">
                <v-toolbar class="mb-2 mt-5 pl-2" color="grey-darken-2" dense>
                  <div style="color: white">
                    <strong>General Information</strong>
                  </div>
                </v-toolbar>
              </v-col>
              <v-col class="pr-5" xs="6" md="6" lg="6">
                <v-text-field
                  v-if="institution && institution.title"
                  v-model="institution.title"
                  :label="$t('institutions.form.title')"
                  :rules="rules.requiredLetters"
                  color="red-darken-1"
                  prepend-icon="mdi-domain"
                />
              </v-col>
              <!--------------------------------------ADDRESS-------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.address"
                  :label="$t('institutions.form.address')"
                  :rules="rules.requiredLetters"
                  color="red-darken-1"
                  prepend-icon="mdi-list-box-outline"
                />
              </v-col>

              <!---------------------------------------STATE--------------------------------------->
              <v-col class="pr-5" xs="6" md="6" lg="6">
                <v-select
                  v-model="institution.state"
                  :items="states"
                  :label="$t('institutions.form.state')"
                  :loading="loadingState"
                  :rules="rules.required"
                  color="red-darken-1"
                  item-title="name"
                  item-value="name"
                  prepend-icon="mdi-earth"
                  return-object
                />
              </v-col>
              <!---------------------------------------CITY---------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-select
                  v-model="institution.city"
                  :items="cities"
                  :label="$t('institutions.form.city')"
                  :loading="loadingCity"
                  :rules="rules.required"
                  color="red-darken-1"
                  item-title="name"
                  item-value="name"
                  prepend-icon="mdi-city"
                />
              </v-col>
              <!---------------------------------------PHONE--------------------------------------->
              <v-col class="pr-5" xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.phone"
                  :label="$t('institutions.form.phone')"
                  :rules="rules.requiredNumbers"
                  color="red-darken-1"
                  prepend-icon="mdi-phone"
                  type="number"
                />
              </v-col>
              <!--------------------------------------WEBSITE-------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.website"
                  :label="$t('institutions.form.website')"
                  :rules="rules.requiredLetters"
                  color="red-darken-1"
                  prepend-icon="mdi-web"
                />
              </v-col>
              <!-------------------------------------LEKOSHOP-------------------------------------->
              <v-col class="pr-5" xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.shop"
                  :label="$t('institutions.table.shop')"
                  color="red-darken-1"
                  prepend-icon="mdi-store"
                />
              </v-col>
              <!---------------------------------------Email--------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.email"
                  :label="$t('institutions.form.email')"
                  :rules="rules.email"
                  color="red-darken-1"
                  prepend-icon="mdi-email"
                />
              </v-col>
              <!--------------------------------------RR Email------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.rrEmail"
                  :label="$t('institutions.form.rr_email')"
                  :rules="rules.optionalEmail"
                  color="red-darken-1"
                  prepend-icon="mdi-email-outline"
                />
              </v-col>
              <!------------------------------------REFERRED BY------------------------------------->
              <v-col
                v-if="$store.getters.role === 'SuperAdmin'"
                xs="6"
                md="6"
                lg="6"
              >
                <v-autocomplete
                  v-model="institution.referred_by"
                  :items="filteredInstitutions"
                  :loading="loadingInstitutions"
                  :label="$t('institutions.form.referred_by')"
                  color="red-darken-1"
                  item-title="title"
                  item-value="_id"
                  prepend-icon="mdi-account-arrow-right-outline"
                  clearable
                />
              </v-col>
              <!-- TYPE -->
              <v-col class="pr-5" xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.type"
                  :label="$t('institutions.form.type')"
                  :rules="rules.requiredLetters"
                  color="red-darken-1"
                  prepend-icon="mdi-office-building-cog-outline"
                />
              </v-col>
              <!---------------------------FISCAL INFORMATION--------------------------------------->
              <v-col cols="12">
                <v-toolbar class="mb-2 mt-5 pl-2" color="grey-darken-2" dense>
                  <div style="color: white">
                    <strong>{{
                      $t("institutions.form.fiscal_information")
                    }}</strong>
                  </div>
                </v-toolbar>
              </v-col>
              <v-col class="pr-5" xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.fiscalInformation.companyName"
                  :label="$t('institutions.form.company_name')"
                  color="red-darken-1"
                  prepend-icon="mdi-domain"
                />
              </v-col>
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.fiscalInformation.legalAddress"
                  :label="$t('institutions.form.legal_address')"
                  color="red-darken-1"
                  prepend-icon="mdi-map-marker-outline"
                />
              </v-col>
              <v-col class="pr-5" xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.fiscalInformation.vatNumber"
                  :label="$t('institutions.form.vat_number')"
                  color="red-darken-1"
                  prepend-icon="mdi-identifier"
                />
              </v-col>
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.fiscalInformation.taxCode"
                  :label="$t('institutions.form.tax_code')"
                  color="red-darken-1"
                  prepend-icon="mdi-card-account-details-outline"
                />
              </v-col>
              <v-col class="pr-5" xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.fiscalInformation.legalRepresentative"
                  :label="$t('institutions.form.legal_representative')"
                  color="red-darken-1"
                  prepend-icon="mdi-account-tie"
                />
              </v-col>
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="institution.fiscalInformation.uniqueCode"
                  :label="$t('institutions.form.unique_code')"
                  color="red-darken-1"
                  prepend-icon="mdi-barcode"
                />
              </v-col>
              <v-col cols="12">
                <v-toolbar class="mb-2 mt-5 pl-2" color="grey-darken-2" dense>
                  <div style="color: white">
                    <strong>Available Services</strong>
                  </div>
                </v-toolbar>
              </v-col>
              <v-col xs="6" md="6" lg="6">
                <v-row class="d-flex flex-nowrap">
                  <!-- First column with 4 elements -->
                  <v-col class="mr-4" xs="6" md="6" lg="6">
                    <!-- STATUS -->
                    <v-switch
                      v-model="institution.user_status"
                      :label="$t('institutions.form.user_status')"
                      class="mb-2"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                    />
                    <!-- EXPORT EBAY MULTIBREVES-->
                    <!-- <v-switch
                      v-model="institution.export_ebay"
                      :label="$t('institutions.table.exportEbay')"
                      class="mb-2 mr-2"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                    /> -->
                    <!-- EXPORT EBAY LEKO-->
                    <v-switch
                      v-model="institution.export_ebay_leko"
                      :label="$t('institutions.table.exportEbayLeko')"
                      class="mb-2 mr-2"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                      hide-details
                      :disabled="!checkEbay()"
                    />
                    <div class="ml-5 grey--text">
                      <v-icon
                        v-if="checkEbayDetails(institution)"
                        small
                        color="grey-darken-2"
                        class="pl-4 pr-3"
                      >
                        mdi-check-circle-outline </v-icon
                      ><v-icon
                        v-if="!checkEbayDetails(institution)"
                        small
                        color="grey-darken-2"
                        class="pl-4 pr-3"
                      >
                        mdi-cancel
                      </v-icon>
                      <strong
                        class="pa-0 ma-0"
                        role="button"
                        @click="openEbayDetails(institution)"
                        >{{ $t("institutions.table.ebay_details") }}</strong
                      >
                      <strong
                        v-if="
                          institution &&
                          institution.eBayDetails &&
                          institution.eBayDetails.tokenExpirationDate
                        "
                      >
                        {{
                          "(" +
                          institution.eBayDetails.tokenExpirationDate.slice(
                            0,
                            7,
                          ) +
                          ")"
                        }}</strong
                      >
                    </div>
                    <div class="ml-5 grey--text">
                      <v-icon
                        class="pl-4 pr-3"
                        small
                        color="grey-darken-2"
                        @click="openEbayStoreCategories(institution)"
                      >
                        mdi-format-list-bulleted
                      </v-icon>
                      <strong
                        role="button"
                        @click="openEbayStoreCategories(institution)"
                      >
                        {{ $t("institutions.table.ebay_store_categories") }}
                      </strong>
                    </div>
                    <div class="ml-5 grey--text d-flex">
                      <v-switch
                        v-model="institution.add_to_ebay_on_approve"
                        :label="$t('institutions.table.add_to_ebay_on_approve')"
                        class="mb-2 ml-4"
                        color="red-darken-1"
                        hide-details
                      />
                    </div>
                    <div class="ml-5 grey--text">
                      <span class="ml-3">
                        <v-icon color="grey-darken-2">mdi-repeat</v-icon>
                        <v-icon color="grey-darken-2">mdi-firefox</v-icon>
                      </span>
                      <strong
                        role="button"
                        @click="openEbayPreferences(institution)"
                      >
                        {{ $t("institutions.table.preferences") }}
                      </strong>
                    </div>
                    <!-- EXPORT PARTS -->
                    <v-switch
                      v-model="institution.export_parts"
                      :label="$t('institutions.table.exportParts')"
                      class="mb-2"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                    />
                    <!-- EXPORT TEMPORARY PARTS -->
                    <v-switch
                      v-model="institution.export_temporary_parts"
                      :label="$t('institutions.table.exportTempParts')"
                      class="mb-2"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                    />
                    <!-- DISPLAY SHOP -->
                    <v-col xs="12" md="12" lg="12">
                      <v-switch
                        v-model="institution.display_shop"
                        :label="$t('institutions.form.displayShop')"
                        color="red-darken-1"
                        prepend-icon="mdi-poll"
                      />
                    </v-col>
                  </v-col>
                  <!-- Second column with 3 elements -->
                  <v-col xs="6" md="6" lg="6">
                    <v-switch
                      v-model="institution.export_sales"
                      :label="$t('institutions.table.exportSales')"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                    />

                    <!-- STATS -->
                    <v-switch
                      v-model="institution.stats"
                      :disabled="!institution.email"
                      :label="$t('institutions.form.stats')"
                      class="mb-2"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                    />
                    <!-- INFOCAR CAD -->
                    <v-switch
                      v-if="institution && institution.preferences"
                      v-model="
                        institution.preferences.displayFeatures.infoCarCad
                      "
                      :label="$t('institutions.form.infoCarCad')"
                      class="mb-2"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                    />

                    <!--IMAGES BACKGROUND REMOVAL-->
                    <v-switch
                      v-if="institution && institution.preferences"
                      v-model="
                        institution.preferences.displayFeatures
                          .removeImagesBackground
                      "
                      :label="$t('institutions.form.removeImagesBackground')"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                    />
                    <v-switch
                      v-model="institution.export_google_merchant_leko"
                      :label="$t('institutions.table.exportGoogle')"
                      class="mb-2 mr-2"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                      hide-details
                      :disabled="!checkGoogle()"
                    />
                    <div class="ml-5 grey--text">
                      <v-icon v-if="checkGoogle()" small class="pl-4 pr-3">
                        mdi-check-circle-outline </v-icon
                      ><v-icon v-if="!checkGoogle()" small class="pl-4 pr-3">
                        mdi-cancel
                      </v-icon>
                      <strong
                        class="pa-0 ma-0"
                        role="button"
                        @click="openGoogleDetails(institution)"
                        >{{ $t("institutions.table.google_details") }}</strong
                      >
                    </div>
                    <v-switch
                      v-model="institution.custom_shop"
                      :label="$t('institutions.table.custom_shop')"
                      class="mb-2 mr-2"
                      color="red-darken-1"
                      prepend-icon="mdi-poll"
                      hide-details
                    />
                    <div
                      v-if="hasCustomShopUsers"
                      class="ml-5 grey--text"
                      @click="seeUsers()"
                    >
                      <v-icon small class="pl-4 pr-3" color="grey-darken-2">
                        mdi-check-circle-outline
                      </v-icon>
                      <strong>
                        {{ customShopUsers.length }}
                        users
                      </strong>
                    </div>
                    <div class="ml-5 grey--text">
                      <v-icon
                        small
                        class="pl-4 pr-3"
                        color="grey-darken-2"
                        @click="openCustomShop(institution)"
                      >
                        mdi-plus
                      </v-icon>
                      <strong
                        class="pa-0 ma-0"
                        role="button"
                        @click="openCustomShop(institution)"
                        >{{
                          $t("institutions.table.custom_shop_add_user")
                        }}</strong
                      >
                    </div>
                    <div class="ml-5 grey--text d-flex">
                      <v-switch
                        v-model="institution.aziendaRR"
                        label="AziendaRR"
                        class="mb-2 ml-4"
                        color="red-darken-1"
                        hide-details
                      />
                    </div>
                    <div class="ml-5 grey--text d-flex">
                      <v-switch
                        v-model="institution.rr"
                        label="RR"
                        class="mb-2 ml-4"
                        color="red-darken-1"
                        hide-details
                      />
                    </div>
                    <div
                      v-if="$store.getters.role === 'SuperAdmin'"
                      class="ml-5 grey--text d-flex"
                    >
                      <v-switch
                        v-model="institution.rrMember"
                        :label="$t('institutions.table.rr_member')"
                        class="mb-2 ml-4"
                        color="red-darken-1"
                        hide-details
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-col>

              <!-- Right side with xs="6" -->
              <v-col xs="6" md="6" lg="6">
                <!-- PARTS -->
                <v-row v-if="institution.parts" align-center row wrap>
                  <v-col sm="4" xs="12" md="4" lg="4">
                    <span class="subheading grey--text text--darken-1">
                      {{ $t("institutions.form.type_of_parts") }}:
                    </span>
                  </v-col>
                  <v-col>
                    <v-checkbox
                      v-model="institution.parts.new"
                      :label="$t('institutions.form.new')"
                      color="primary"
                    />
                  </v-col>
                  <v-col>
                    <v-checkbox
                      v-model="institution.parts.used"
                      :label="$t('institutions.form.used')"
                      color="primary"
                    />
                  </v-col>
                </v-row>

                <!-- PLATES -->
                <v-row row>
                  <v-col xs="6" md="6" lg="6">
                    <v-text-field
                      v-if="institution.plates"
                      v-model="institution.plates.used"
                      :label="$t('institutions.form.total_plates')"
                      color="red-darken-1"
                      readonly
                      type="number"
                    />
                  </v-col>
                  <v-col xs="6" md="6" lg="6">
                    <v-text-field
                      v-if="institution.plates"
                      v-model="institution.plates.remaining"
                      :label="$t('institutions.form.remaining_plates')"
                      color="red-darken-1"
                      min="0"
                      oninput="validity.valid||(value='');"
                      step="1"
                      type="number"
                    />
                  </v-col>
                  <v-col xs="6" md="6" lg="6">
                    <v-text-field
                      v-if="institution.usedPlatesNumber"
                      v-model="institution.usedPlatesNumber"
                      :label="$t('institutions.form.used_plates')"
                      color="red-darken-1"
                      readonly
                      type="number"
                  /></v-col>
                </v-row>
              </v-col>
              <!----------------------------------------------------------------------------------->
              <v-col cols="12">
                <!---------------------------ADDITIONAL CONTACT--------------------------------------->
                <v-toolbar class="mb-2 mt-5 pl-2" color="grey-darken-2" dense>
                  <div style="color: white">
                    <strong>Additional Contact Information</strong>
                  </div>
                </v-toolbar>
              </v-col>

              <v-col class="pr-5" xs="6" md="6" lg="6">
                <v-text-field
                  v-model="whatsapp_number"
                  :label="$t('institutions.form.whatsAppChatBot')"
                  color="red-darken-1"
                  prepend-icon="mdi-phone"
                  @input="updatePhone('whatsapp_number', $event)"
                />
              </v-col>
              <v-switch
                v-model="whatsapp_status"
                :label="$t('institutions.form.enable_whatsapp')"
                class="mb-2"
                color="red-darken-1"
                prepend-icon="mdi-poll"
              />
              <!--------------------------------------ADDRESS-------------------------------------->
              <v-col xs="6" md="6" lg="6">
                <v-text-field
                  v-model="optin_number"
                  :label="$t('institutions.form.optin')"
                  color="red-darken-1"
                  prepend-icon="mdi-phone"
                  @input="updatePhone('optin_number', $event)"
                />
              </v-col>
              <v-switch
                v-model="optin_status"
                :label="$t('institutions.form.enable_optin')"
                class="mb-2"
                color="red-darken-1"
                prepend-icon="mdi-poll"
              />

              <!-----------------------------EBAY WEIGHT RANGES----------------------------------->
              <template
                v-if="
                  (institution.export_ebay_leko || institution.export_ebay) &&
                  ($store.getters.role === 'SuperAdmin' ||
                    $store.getters.role === 'LekoAdmin')
                "
              >
                <v-col cols="12">
                  <v-toolbar class="mb-2 mt-5 pl-2" color="grey-darken-2" dense>
                    <div
                      style="color: white"
                      class="d-flex align-center"
                    >
                      <strong>Weight Ranges</strong>
                      <v-tooltip location="bottom" max-width="320">
                        <template #activator="{ props }">
                          <v-icon
                            v-bind="props"
                            size="small"
                            color="white"
                            class="ml-2"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>
                          These weight ranges are currently used on eBay to
                          associate parts with shipping policies.
                        </span>
                      </v-tooltip>
                    </div>
                  </v-toolbar>
                  <v-progress-linear
                    v-if="loadingWeightRanges"
                    indeterminate
                    color="red-darken-1"
                  />
                  <template v-else>
                    <v-chip-group
                      v-model="selectedWeightRanges"
                      multiple
                      column
                      class="px-1"
                    >
                      <v-chip
                        v-for="range in allWeightRanges"
                        :key="range"
                        :value="range"
                        filter
                        size="small"
                        color="red-darken-1"
                        variant="outlined"
                      >
                        {{ range }}
                      </v-chip>
                    </v-chip-group>
                    <div class="d-flex align-center mt-1">
                      <span
                        class="text-caption grey--text mr-3"
                        role="button"
                        style="cursor: pointer"
                        @click="selectAllWeightRanges"
                      >Select all</span>
                      <span
                        class="text-caption grey--text"
                        role="button"
                        style="cursor: pointer"
                        @click="clearAllWeightRanges"
                      >Clear all</span>
                      <v-spacer />
                      <v-btn
                        :loading="savingWeightRanges"
                        color="green-darken-1"
                        variant="outlined"
                        size="small"
                        @click="saveWeightRanges"
                      >
                        Save Weight Ranges
                      </v-btn>
                    </div>
                  </template>
                </v-col>
              </template>

              <!-----------------------DISMANTLING & COMPLIANCE SWITCHES-------------------------->
              <compliance-switches
                v-if="$store.getters.role === 'SuperAdmin'"
                :institution-id="$route.params.id"
                :institution-title="institution.title || ''"
              />
            </v-row>
          </v-container>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="red-darken-1"
              variant="outlined"
              @click="onCancelClick"
            >
              {{ $t("institutions.form.close") }}
            </v-btn>
            <v-btn
              :disabled="!valid"
              :loading="loading"
              color="green-darken-1"
              variant="outlined"
              @click="save"
            >
              {{ $t("institutions.form.save") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
    <ebay-dialog
      ref="ebayDetailsFile"
      @fetch-institution-details="fetchInstitutionDetails"
      @valid="handleValid"
    />
    <google-dialog
      ref="googleDetailsFile"
      @fetch-institution-details="fetchInstitutionDetails"
      @valid="handleValid"
    />
    <custom-shop
      ref="customShopFile"
      @fetch-institution-details="fetchInstitutionDetails"
      @valid="handleValid"
    />
  </v-container>
</template>

<script>
import postRequest from "@/api/postRequest";
import putRequest from "@/api/putRequest";
import ebay from "@/components/Institutions/ebayDetails.vue";
import google from "@/components/Institutions/googleDetails.vue";
import customShop from "@/components/Institutions/customShop.vue";
import complianceSwitches from "@/components/Institutions/complianceSwitches.vue";
import getRequest from "../../api/getRequest";

function dataURLtoBlob(dataUrl) {
  // convert base64 to raw binary data held in a string
  const byteString = atob(dataUrl.split(",")[1]);
  // separate out the mime component
  const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0];
  // write the bytes of the string to an ArrayBuffer
  const ab = new ArrayBuffer(byteString.length);
  // create a view into the buffer
  const ia = new Uint8Array(ab);
  // set the bytes of the buffer to the correct values
  for (let i = 0; i < byteString.length; i += 1) {
    ia[i] = byteString.charCodeAt(i);
  }
  // write the ArrayBuffer to a blob, and you're done
  return new Blob([ab], { type: mimeString });
}

export default {
  components: {
    "ebay-dialog": ebay,
    "google-dialog": google,
    "custom-shop": customShop,
    "compliance-switches": complianceSwitches,
  },
  data() {
    return {
      uploadedImages: [],
      logo: null,
      tmpLogo: "",
      valid: false,
      edit: null,
      dialog: false,
      loading: false,
      loadingState: false,
      loadingCity: false,
      rules: {
        requiredLetters: [
          (v) => !!v || "Please fill this field",
          (v) => /[A-Za-z]/.test(v) || "Only letters are allowed",
        ],
        requiredNumbers: [
          (v) => !!v || "Please fill this field",
          (v) => /[0-9]/.test(v) || "Only numbers are allowed",
        ],
        email: [
          (v) => !!v || "Please fill this field",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
        optionalEmail: [
          (v) => !v || /.+@.+/.test(v) || "E-mail must be valid",
        ],
      },
      institution: {
        fiscalInformation: {
          companyName: null,
          legalAddress: null,
          vatNumber: null,
          taxCode: null,
          legalRepresentative: null,
          uniqueCode: null,
        },
      },
      states: [],
      state: {},
      cities: [],
      institutions: [],
      loadingInstitutions: false,
      validCategories: false,
      whatsapp_number: "",
      whatsapp_status: false,
      optin_number: "",
      optin_status: false,
      customShopUsers: [],
      hasCustomShopUsers: false,
      allWeightRanges: [],
      selectedWeightRanges: [],
      loadingWeightRanges: false,
      savingWeightRanges: false,
      snackbar: { message: "", color: "success", value: false },
    };
  },
  computed: {
    server() {
      return this.$serverUri;
    },
    filteredInstitutions() {
      return this.institutions.filter((i) => i._id !== this.institution._id);
    },
  },
  watch: {
    state(value) {
      if (value) {
        this.institution.state = value.name;
      }
    },
    // Mirrors the API: enabling RR grants membership, disabling it never revokes it.
    // Also seeds rrEmail from email when empty so new RR members start with a contact.
    "institution.rr"(value) {
      if (value === true) {
        this.institution.rrMember = true;
        if (!this.institution.rrEmail && this.institution.email) {
          this.institution.rrEmail = this.institution.email;
        }
      }
    },
  },
  created() {
    this.fetchInstitutionDetails();
    this.getStates();
    this.getCities();
    if (this.$store.getters.role === 'SuperAdmin') this.getInstitutions();
    if (
      this.$store.getters.role === 'SuperAdmin' ||
      this.$store.getters.role === 'LekoAdmin'
    ) {
      this.fetchWeightRanges();
    }
  },
  methods: {
    updatePhone(field, value) {
      // Keep only numbers, `+`, and spaces. Remove invalid characters.
      this[field] = value
        .replace(/[^+\d\s]/g, "")
        .replace(/(?!^)\+/g, "")
        .replace(/^(?![\d+])./, "");
    },
    handleValid(value) {
      this.validCategories = value;
    },
    open(edit, data) {
      this.edit = edit;
      // Add the plates object if it doesn't exist
      if (!data.plates) data.plates = { used: 0, remaining: 0 };
      this.institution = data;
      this.dialog = true;

      // Update the state property if institution's state is available
      if (data.state) {
        this.state = data.state;
        // this.getCities(data.state._id);
      } else {
        this.state = {}; // Reset the state
        this.cities = []; // Reset the cities
      }
    },
    close() {
      this.institution = { plates: { used: 0, remaining: 0 } };
      this.states = [];
      this.state = {};
      this.cities = [];
      this.logo = null;
      this.dialog = false;
      this.loading = false;
      // this.$emit('close');
    },
    onInput(input) {
      const { files } = input.target;
      if (files && files.length > 0) {
        const { type } = files[0];
        const extension = type.split("/")[1];
        const fileReader = new FileReader();

        fileReader.readAsDataURL(files[0]);

        fileReader.addEventListener("load", () => {
          const dataUrl = fileReader.result;
          this.tmpLogo = dataUrl;
          this.logo = { blob: dataURLtoBlob(dataUrl), extension }; // Set the logoUrl immediately
        });
      }
    },
    getStates() {
      this.loadingState = true;
      getRequest("/state")
        .then((response) => {
          this.states = response.states;
          this.loadingState = false;
          if (this.institution.state) {
            // select institution's state
            this.states.forEach((state) => {
              if (state.name === this.institution.state) this.state = state;
            });
          }
        })
        .catch((error) => {
          if (error) {
            this.loadingState = false;
          }
        });
    },
    getCities(id) {
      this.loadingCity = true;
      getRequest("/city", `state_id=${id}`)
        .then((response) => {
          this.cities = response.cities;
          this.loadingCity = false;
        })
        .catch((error) => {
          if (error) {
            this.loadingCity = false;
          }
        });
    },
    getInstitutions() {
      this.loadingInstitutions = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          this.loadingInstitutions = false;
        })
        .catch(() => {
          this.loadingInstitutions = false;
        });
    },

    onCancelClick() {
      // Go back to the previous page
      this.$router.push("/institutions"); // Redirect to /institutions
    },

    save() {
      if (this.$refs.form2 && this.$refs.form2.validate()) {
        this.loading = true;

        const formData = new FormData();
        this.institution.preferences.whatsappChatbot.phone =
          this.whatsapp_number;
        this.institution.preferences.whatsappChatbot.enabled =
          this.whatsapp_status;
        this.institution.preferences.optIn.phone = this.optin_number;
        this.institution.preferences.optIn.enabled = this.optin_status;
        // Check if a new logo was uploaded and add it to the form data
        if (this.logo !== null)
          formData.append(
            "logo",
            this.logo.blob,
            `logo.${this.logo.extension}`,
          );
        formData.append("institution", JSON.stringify(this.institution));

        // Send the request to update the institution
        postRequest
          .formData("/institution/edit", `id=${this.institution._id}`, formData)
          .then(() => {
            this.$router.push("/institutions"); // Redirect to /institutions
            this.$emit("success", "Successfully edited");
          })
          .catch(() => {});
      }
    },

    async fetchInstitutionDetails() {
      const institutionId = this.$route.params.id;

      try {
        const response = await getRequest(
          "/institution",
          `id=${institutionId}`,
        );

        // Check if the response contains an 'institution' property
        if (response.institution) {
          this.institution = response.institution[0];
          if (!this.institution.fiscalInformation) {
            this.institution.fiscalInformation = {
              companyName: null,
              legalAddress: null,
              vatNumber: null,
              taxCode: null,
              legalRepresentative: null,
              uniqueCode: null,
            };
          } else if (this.institution.fiscalInformation.uniqueCode === undefined) {
            this.institution.fiscalInformation.uniqueCode = null;
          }
          this.whatsapp_number = this.institution.preferences.whatsappChatbot
            .phone
            ? this.institution.preferences.whatsappChatbot.phone
            : "";
          this.whatsapp_status =
            this.institution.preferences.whatsappChatbot.enabled;
          this.optin_number = this.institution.preferences.optIn.phone
            ? this.institution.preferences.optIn.phone
            : "";
          this.optin_status = this.institution.preferences.optIn.enabled;
          this.hasCustomShopUsers = !!(
            this.institution.customShopUsers &&
            this.institution.customShopUsers.length > 0
          );
          this.customShopUsers = this.institution.customShopUsers
            ? this.institution.customShopUsers
            : [];
          this.isLoading = true; // Data is loaded, set isLoading to false
          this.checkEbay();
        } else {
          this.error = "Institution not found"; // Set an error message
          this.isLoading = false; // Set isLoading to false
        }
      } catch (error) {
        if (error) {
          this.error = "An error occurred while fetching data"; // Set an error message
          this.isLoading = false; // Set isLoading to false
        }
      }
    },
    checkEbay() {
      // Check if eBayDetails exists and is an object
      if (!this.institution.eBayDetails) {
        return false;
      }
      // if (!this.validCategories) {
      //   return false;
      // }
      // Check the required properties in eBayDetails
      return (
        this.institution.eBayDetails.token &&
        this.institution.eBayDetails.tokenExpirationDate &&
        this.institution.eBayDetails.shippingId &&
        this.institution.eBayDetails.paymentId &&
        this.institution.eBayDetails.returnId
      );
    },
    checkEbayDetails(institution) {
      if (!institution || !institution.eBayDetails) {
        return false;
      }
      const { token, tokenExpirationDate, shippingId, paymentId, returnId } =
        institution.eBayDetails;
      if (token && tokenExpirationDate && shippingId && paymentId && returnId) {
        return true;
      }
      return false;
    },
    openEbayDetails(institution) {
      const { ebayDetailsFile } = this.$refs;
      ebayDetailsFile.openEbayDetailsModal(institution);
    },
    openEbayStoreCategories(institution) {
      const { ebayDetailsFile } = this.$refs;
      ebayDetailsFile.openEbayStoreCategoriesModal(institution);
    },
    openEbayPreferences(institution) {
      const { ebayDetailsFile } = this.$refs;
      ebayDetailsFile.openEbayPreferencesModal(institution);
    },
    checkGoogle() {
      return this.institution.googleMerchantId;
    },
    checkAuth() {
      return false;
    },
    openGoogleDetails(institution) {
      const { googleDetailsFile } = this.$refs;
      googleDetailsFile.openGoogleDetailsModal(institution);
    },
    openCustomShop(institution) {
      const { customShopFile } = this.$refs;
      customShopFile.openCustomShopModal(institution);
    },
    seeUsers() {
      const { customShopFile } = this.$refs;
      customShopFile.openCustomShopUsers(this.customShopUsers);
    },

    fetchWeightRanges() {


      const institutionId = this.$route.params.id;
      this.loadingWeightRanges = true;
      getRequest("/institution/weight-ranges", `institution_id=${institutionId}`)
        .then((response) => {
          this.allWeightRanges = response.allWeightRanges || [];
          if (
            response.configuredAllowedWeightRanges &&
            response.configuredAllowedWeightRanges.length === 0
          ) {
            this.selectedWeightRanges = [...(response.allWeightRanges || [])];
          } else {
            this.selectedWeightRanges = response.configuredAllowedWeightRanges || [];
          }
          this.loadingWeightRanges = false;
        })
        .catch(() => {
          this.loadingWeightRanges = false;
        });
    },

    saveWeightRanges() {
      const institutionId = this.$route.params.id;
      this.savingWeightRanges = true;
      const payload = [...this.selectedWeightRanges];
      putRequest(
        `/institution/edit-weight-ranges/${institutionId}`,
        "",
        { allowedWeightRanges: payload },
      )
        .then((response) => {
          this.savingWeightRanges = false;
          const { message, allowedWeightRanges, allWeightRanges } =
            response.data || {};
          this.snackbar.message =
            message || "Weight ranges updated successfully.";
          this.snackbar.color = "success";
          this.snackbar.value = true;
          if (allWeightRanges) {
            this.allWeightRanges = allWeightRanges;
          }
          if (Array.isArray(allowedWeightRanges)) {
            if (allowedWeightRanges.length === 0) {
              this.selectedWeightRanges = [...this.allWeightRanges];
            } else {
              this.selectedWeightRanges = [...allowedWeightRanges];
            }
          }
        })
        .catch(() => {
          this.savingWeightRanges = false;
        });
    },

    selectAllWeightRanges() {
      this.selectedWeightRanges = [...this.allWeightRanges];
    },

    clearAllWeightRanges() {
      this.selectedWeightRanges = [];
    },
  },
};
</script>
<style>
.grey--text {
  color: grey;
}
</style>
